import {
  Table,
  TableContainer,
  Tbody,
  Td,
  Th,
  Thead,
  Tr,
} from '@chakra-ui/react';
import { useState, useEffect } from 'react';
import { FaEdit } from 'react-icons/fa';
import { MdDelete } from 'react-icons/md';
import { PiWarningCircleBold } from 'react-icons/pi';
import * as React from 'react';
import { IoMdAdd } from 'react-icons/io';
import { useDispatch, useSelector } from 'react-redux';
import { Button, Form } from 'react-bootstrap';
import Modal from 'react-bootstrap/Modal';
import ReactPaginate from 'react-paginate';
import { IoSearchOutline } from 'react-icons/io5';
import { Formik, ErrorMessage } from 'formik';
import * as Yup from 'yup';
import {
  getAdmins,
  addSubAdmin,
  updateSubAdmin,
  deleteSubAdmin,
} from '../../../redux/actions/SuperAdmin.action';
import WaDaddyForm, {
  saveWaDaddyCredential,
  fetchWaDaddyCredential,
} from '../WaDaddy';
import CtcCredentialsForm, {
  saveCtcCredential,
  fetchCtcCredential,
} from '../CtcCredentials';
import { getPlans } from '../../../redux/actions/Plan.action';
import logo from '../../../assets/img/mizoLogo.png';

const SubAdminList = () => {
  const dispatch = useDispatch();
  const admins = useSelector((state) => state.superAdmin);

  const plans = useSelector((state) => state.plan);

  const [show, setShow] = useState(false);
  const [updateModal, setUpdateModal] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);
  const [selectedAdmin, setSelectedAdmin] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [searchQuery, setSearchQuery] = useState('');
  const [selectedPlan, setSelectedPlan] = useState('');
  const [allowPlanUpdate, setAllowPlanUpdate] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [waDaddyCredential, setWaDaddyCredential] = useState(null);
  const [ctcCredential, setCtcCredential] = useState(null);

  const indexOfLastRow = currentPage * rowsPerPage;
  const totalCount = admins?.getAdmins?.data?.totalCount || 0;

  const handleAddModalClose = () => {
    setShow(false);
  };
  const handleAddModalOpen = () => setShow(true);

  const handleUpdateModalClose = () => {
    setUpdateModal(false);
    setSelectedAdmin(null);
    setAllowPlanUpdate(false);
    setWaDaddyCredential(null);
    setCtcCredential(null);
  };

  const handleUpdateModalOpen = async (admin) => {
    setSelectedAdmin(admin);
    setUpdateModal(true);
    if (admin?.isWadaddy) {
      const credential = await fetchWaDaddyCredential(dispatch, admin._id);
      setWaDaddyCredential(credential);
    } else {
      setWaDaddyCredential(null);
    }
    if (admin?.isIvr) {
      const ctcCred = await fetchCtcCredential(dispatch, admin._id);
      setCtcCredential(ctcCred);
    } else {
      setCtcCredential(null);
    }
  };

  const handleDeleteModalClose = () => {
    setDeleteModal(false);
    setSelectedAdmin(null);
  };

  const handleDeleteModalOpen = (admin) => {
    setSelectedAdmin(admin);
    setDeleteModal(true);
  };

  const initialValues = {
    name: '',
    email: '',
    phoneNumber: '',
    type: 'Admin',
    planId: '',
    startDate: '',
    endDate: '',
    password: '',
    // facebookPageAccessToken: '',
    facebookPageAccessTokens: [''],
    logo: '', // Add logo field
    voiceAIPermission: false,
    voiceAIDetails: {
      OMNIDIM_API_KEY: '',
      OMNIDIM_DEFAULT_PHONE_NUMBER_ID: '',
      OMNIDIM_BASE_URL: '',
      callStatus: false,
    },
    isWadaddy: false,
    isIvr: false,
    CLINumber: '',
    facebookAppId: '',
    registerdPhoneNumber: '',
    phoneNumberId: '',
    wbaId: '',
    accessToken: '',
    apikey: '',
  };

  const validationSchema = Yup.object().shape({
    name: Yup.string().required('Name is required'),
    email: Yup.string().email('Invalid email').required('Email is required'),
    phoneNumber: Yup.string().required('Phone number is required'),
    planId: Yup.string().when('$isUpdate', {
      is: true,
      then: (schema) =>
        allowPlanUpdate ? schema.required('Plan is required') : schema,
      otherwise: (schema) => schema.required('Plan is required'),
    }),
    startDate: Yup.date().when('$isUpdate', {
      is: true,
      then: (schema) =>
        allowPlanUpdate ? schema.required('Start date is required') : schema,
      otherwise: (schema) => schema.required('Start date is required'),
    }),
    endDate: Yup.date().when('$isUpdate', {
      is: true,
      then: (schema) =>
        allowPlanUpdate ? schema.required('End date is required') : schema,
      otherwise: (schema) => schema.required('End date is required'),
    }),
    password: Yup.string().required('Password is required'),
    // facebookPageAccessToken: Yup.string()
    facebookPageAccessTokens: Yup.array()
      .of(Yup.string().required('Token is required'))
      .max(5, 'You can add up to 5 tokens only'),
    facebookAppId: Yup.string().when('isWadaddy', {
      is: true,
      then: (schema) => schema.required('Facebook App ID is required'),
    }),
    registerdPhoneNumber: Yup.string().when('isWadaddy', {
      is: true,
      then: (schema) => schema.required('Registered Number is required'),
    }),
    phoneNumberId: Yup.string().when('isWadaddy', {
      is: true,
      then: (schema) => schema.required('Phone Number Id is required'),
    }),
    wbaId: Yup.string().when('isWadaddy', {
      is: true,
      then: (schema) =>
        schema.required('WhatsApp Business Account Id is required'),
    }),
    accessToken: Yup.string().when('isWadaddy', {
      is: true,
      then: (schema) => schema.required('Permanent Access Token is required'),
    }),
    apikey: Yup.string().when('isWadaddy', {
      is: true,
      then: (schema) => schema.required('Api Key is required'),
    }),
  });

  useEffect(() => {
    dispatch(
      getPlans({
        page: 1,
        limit: 100,
      }),
    );
  }, [dispatch]);

  useEffect(() => {
    const params = {
      page: currentPage,
      limit: rowsPerPage,
      search: searchQuery,
      planId: selectedPlan,
    };
    dispatch(getAdmins(params));
  }, [dispatch, currentPage, rowsPerPage, searchQuery, selectedPlan]);

  // const handleSubmit = async (values, { resetForm }) => {
  //   setIsSubmitting(true); // Set loading state to true
  //   const formData = new FormData();

  //   Object.keys(values).forEach((key) => {
  //     if (key === 'logo' && values[key]) {
  //       formData.append('logo', values[key]);
  //     } else {
  //       formData.append(key, values[key]);
  //     }
  //   });

  //   try {
  //     await dispatch(
  //       addSubAdmin(formData, {
  //         page: currentPage,
  //         limit: rowsPerPage,
  //         search: searchQuery,
  //       }),
  //     );
  //     resetForm();
  //     handleAddModalClose();
  //   } finally {
  //     setIsSubmitting(false); // Set loading state to false regardless of success/failure
  //   }
  // };
  const handleSubmit = async (values, { resetForm }) => {
    setIsSubmitting(true);
    const formData = new FormData();

    // Append all normal fields
    Object.keys(values).forEach((key) => {
      if (key === 'logo' && values[key]) {
        formData.append('logo', values[key]);
      }
      // Handle facebook tokens separately
      else if (key === 'facebookPageAccessTokens') {
        values.facebookPageAccessTokens.forEach((token, index) => {
          formData.append(`facebookPageAccessTokens[${index}]`, token);
        });
      }
      // Handle voiceAIDetails as nested object
      else if (key === 'voiceAIDetails') {
        if (values.voiceAIPermission && values.voiceAIDetails) {
          formData.append('voiceAIPermission', values.voiceAIPermission);
          formData.append(
            'voiceAIDetails[OMNIDIM_API_KEY]',
            values.voiceAIDetails.OMNIDIM_API_KEY || '',
          );
          formData.append(
            'voiceAIDetails[OMNIDIM_DEFAULT_PHONE_NUMBER_ID]',
            values.voiceAIDetails.OMNIDIM_DEFAULT_PHONE_NUMBER_ID || '',
          );
          formData.append(
            'voiceAIDetails[OMNIDIM_BASE_URL]',
            values.voiceAIDetails.OMNIDIM_BASE_URL || '',
          );
          formData.append(
            'voiceAIDetails[callStatus]',
            values.voiceAIDetails.callStatus || false,
          );
        } else {
          formData.append('voiceAIPermission', false);
        }
      }
      // Skip voiceAIDetails and WhatsApp API fields (handled by the separate credential API)
      else if (
        key !== 'voiceAIPermission' &&
        key !== 'facebookAppId' &&
        key !== 'registerdPhoneNumber' &&
        key !== 'phoneNumberId' &&
        key !== 'wbaId' &&
        key !== 'accessToken' &&
        key !== 'apikey'
      ) {
        formData.append(key, values[key]);
      }
    });

    // Append voiceAIPermission if not already appended
    if (!formData.has('voiceAIPermission')) {
      formData.append('voiceAIPermission', values.voiceAIPermission || false);
    }

    try {
      const res = await dispatch(
        addSubAdmin(formData, {
          page: currentPage,
          limit: rowsPerPage,
          search: searchQuery,
        }),
      );

      const newAdminId = res?.data?.user?._id;
      await saveWaDaddyCredential(dispatch, newAdminId, values);
      await saveCtcCredential(dispatch, newAdminId, values);
      resetForm();
      handleAddModalClose();
    } finally {
      setIsSubmitting(false);
    }
  };

  // const handleUpdate = (values) => {
  //   const formData = new FormData();

  //   // Append all form fields to FormData
  //   Object.keys(values).forEach((key) => {
  //     if (key === 'logo' && values[key]) {
  //       formData.append('logo', values[key]);
  //     } else {
  //       formData.append(key, values[key]);
  //     }
  //   });

  //   if (allowPlanUpdate) {
  //     formData.append('planId', values.planId);
  //     formData.append('startDate', values.startDate);
  //     formData.append('endDate', values.endDate);
  //   }

  //   dispatch(
  //     updateSubAdmin(selectedAdmin._id, formData, {
  //       page: currentPage,
  //       limit: rowsPerPage,
  //       search: searchQuery,
  //     }),
  //   ).then(() => {
  //     handleUpdateModalClose();
  //   });
  // };

  const handleUpdate = (values) => {
    const formData = new FormData();

    // Append all normal fields
    Object.keys(values).forEach((key) => {
      if (key === 'logo' && values[key]) {
        formData.append('logo', values[key]);
      }
      // Handle facebook tokens separately
      else if (key === 'facebookPageAccessTokens') {
        values.facebookPageAccessTokens.forEach((token, index) => {
          formData.append(`facebookPageAccessTokens[${index}]`, token);
        });
      }
      // Handle voiceAIDetails as nested object
      else if (key === 'voiceAIDetails') {
        if (values.voiceAIPermission && values.voiceAIDetails) {
          formData.append('voiceAIPermission', values.voiceAIPermission);
          formData.append(
            'voiceAIDetails[OMNIDIM_API_KEY]',
            values.voiceAIDetails.OMNIDIM_API_KEY || '',
          );
          formData.append(
            'voiceAIDetails[OMNIDIM_DEFAULT_PHONE_NUMBER_ID]',
            values.voiceAIDetails.OMNIDIM_DEFAULT_PHONE_NUMBER_ID || '',
          );
          formData.append(
            'voiceAIDetails[OMNIDIM_BASE_URL]',
            values.voiceAIDetails.OMNIDIM_BASE_URL || '',
          );
          formData.append(
            'voiceAIDetails[callStatus]',
            values.voiceAIDetails.callStatus || false,
          );
        } else {
          formData.append('voiceAIPermission', false);
        }
      }
      // Skip voiceAIDetails and WhatsApp API fields (handled by the separate credential API)
      else if (
        key !== 'voiceAIPermission' &&
        key !== 'facebookAppId' &&
        key !== 'registerdPhoneNumber' &&
        key !== 'phoneNumberId' &&
        key !== 'wbaId' &&
        key !== 'accessToken' &&
        key !== 'apikey'
      ) {
        formData.append(key, values[key]);
      }
    });
    // Append voiceAIPermission if not already appended
    if (!formData.has('voiceAIPermission')) {
      formData.append('voiceAIPermission', values.voiceAIPermission || false);
    }
    if (allowPlanUpdate) {
      formData.append('planId', values.planId);
      formData.append('startDate', values.startDate);
      formData.append('endDate', values.endDate);
    }
    dispatch(
      updateSubAdmin(selectedAdmin._id, formData, {
        page: currentPage,
        limit: rowsPerPage,
        search: searchQuery,
      }),
    ).then(async () => {
      await saveWaDaddyCredential(dispatch, selectedAdmin?._id, values);
      await saveCtcCredential(dispatch, selectedAdmin?._id, values);
      handleUpdateModalClose();
    });
  };

  const handleDelete = () => {
    if (selectedAdmin) {
      dispatch(
        deleteSubAdmin(selectedAdmin._id, {
          page: currentPage,
          limit: rowsPerPage,
          search: searchQuery,
        }),
      ).then(() => {
        handleDeleteModalClose();
      });
    }
  };

  const handleSearch = (e) => {
    setSearchQuery(e.target.value);
    setCurrentPage(1);
  };

  const handlePageChange = (selected) => {
    setCurrentPage(selected.selected + 1);
  };

  const handleRowsPerPageChange = (e) => {
    setRowsPerPage(parseInt(e.target.value, 10));
    setCurrentPage(1);
  };

  const formatDateForUI = (dateString) => {
    if (!dateString) return '';
    const date = new Date(dateString);
    return date.toLocaleDateString('en-GB', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
    });
  };

  const renderFormFields = ({
    handleSubmit,
    setFieldValue,
    values,
    handleClose,
  }) => (
    <Form onSubmit={handleSubmit} encType="multipart/form-data">
      <Modal.Body>
        <div className="row">
          <div className="col-12">
            <Form.Group className="mb-3">
              <Form.Label>Name</Form.Label>
              <Form.Control
                type="text"
                name="name"
                value={values.name}
                onChange={(e) => setFieldValue('name', e.target.value)}
                placeholder="Enter name"
                className="shadow-none focus:!border-theme-dark"
              />
              <ErrorMessage
                name="name"
                component="div"
                className="text-danger"
              />
            </Form.Group>
          </div>
          <div className="col-12">
            <Form.Group className="mb-3">
              <Form.Label>Email</Form.Label>
              <Form.Control
                type="email"
                name="email"
                value={values.email}
                onChange={(e) => setFieldValue('email', e.target.value)}
                placeholder="Enter email"
                className="shadow-none focus:!border-theme-dark"
              />
              <ErrorMessage
                name="email"
                component="div"
                className="text-danger"
              />
            </Form.Group>
          </div>
          <div className="col-12">
            <Form.Group className="mb-3">
              <Form.Label>Phone Number</Form.Label>
              <Form.Control
                type="text"
                name="phoneNumber"
                value={values.phoneNumber}
                onChange={(e) => setFieldValue('phoneNumber', e.target.value)}
                placeholder="Enter phone number"
                className="shadow-none focus:!border-theme-dark"
              />
              <ErrorMessage
                name="phoneNumber"
                component="div"
                className="text-danger"
              />
            </Form.Group>
          </div>

          {selectedAdmin && (
            <>
              <div className="col-12 mb-3">
                <Form.Check
                  type="switch"
                  id="active-status-switch"
                  label="Active Status"
                  checked={values.isActive}
                  onChange={(e) => setFieldValue('isActive', e.target.checked)}
                  className="custom-switch"
                />
              </div>
              <div className="col-12 mb-3">
                <Form.Check
                  type="switch"
                  id="plan-update-switch"
                  label="Enable Plan Update"
                  checked={allowPlanUpdate}
                  onChange={(e) => setAllowPlanUpdate(e.target.checked)}
                  className="custom-switch"
                />
              </div>
            </>
          )}

          {(!selectedAdmin || allowPlanUpdate) && (
            <>
              <div className="col-12">
                <Form.Group className="mb-3">
                  <Form.Label>Plan</Form.Label>
                  <Form.Select
                    name="planId"
                    value={values.planId}
                    onChange={(e) => {
                      const selectedPlan = plans?.getPlans?.data?.data?.find(
                        (plan) => plan._id === e.target.value,
                      );
                      const today = new Date();
                      const startDate = today.toISOString().split('T')[0];
                      let endDate = '';
                      if (selectedPlan) {
                        const endDateObj = new Date();
                        endDateObj.setMonth(
                          endDateObj.getMonth() + selectedPlan.duration,
                        );
                        endDate = endDateObj.toISOString().split('T')[0];
                      }
                      setFieldValue('planId', e.target.value);
                      setFieldValue('startDate', startDate);
                      setFieldValue('endDate', endDate);
                    }}
                    className="shadow-none focus:!border-theme-dark"
                  >
                    <option value="">Select Plan</option>
                    {plans?.getPlans?.data?.data &&
                      plans.getPlans.data.data.map((plan) => (
                        <option key={plan._id} value={plan._id}>
                          {plan.planName} ({plan.duration}{' '}
                          {plan.duration === 1 ? 'Month' : 'Months'})
                        </option>
                      ))}
                  </Form.Select>
                  <ErrorMessage
                    name="planId"
                    component="div"
                    className="text-danger"
                  />
                </Form.Group>
              </div>
              <div className="col-6">
                <Form.Group className="mb-3">
                  <Form.Label>Start Date</Form.Label>
                  <Form.Control
                    type="text"
                    name="startDate"
                    value={
                      values.startDate
                        ? new Date(values.startDate).toLocaleDateString('en-GB')
                        : ''
                    }
                    readOnly
                    className="shadow-none focus:!border-theme-dark"
                  />
                  <input
                    type="hidden"
                    name="startDate"
                    value={values.startDate}
                  />
                  <ErrorMessage
                    name="startDate"
                    component="div"
                    className="text-danger"
                  />
                </Form.Group>
              </div>
              <div className="col-6">
                <Form.Group className="mb-3">
                  <Form.Label>End Date</Form.Label>
                  <Form.Control
                    type="text"
                    name="endDate"
                    value={
                      values.endDate
                        ? new Date(values.endDate).toLocaleDateString('en-GB')
                        : ''
                    }
                    readOnly
                    className="shadow-none focus:!border-theme-dark"
                  />
                  <input type="hidden" name="endDate" value={values.endDate} />
                  <ErrorMessage
                    name="endDate"
                    component="div"
                    className="text-danger"
                  />
                </Form.Group>
              </div>
            </>
          )}
          <div className="col-6 mb-3">
            <Form.Check
              type="switch"
              id="is-wadaddy-switch"
              label="WA Daddy"
              checked={values.isWadaddy || false}
              onChange={async (e) => {
                const checked = e.target.checked;
                setFieldValue('isWadaddy', checked);
                if (checked && selectedAdmin?._id) {
                  const credential = await fetchWaDaddyCredential(
                    dispatch,
                    selectedAdmin._id,
                  );
                  if (credential) {
                    setFieldValue('facebookAppId', credential.facebookAppId);
                    setFieldValue(
                      'registerdPhoneNumber',
                      credential.registerdPhoneNumber,
                    );
                    setFieldValue('phoneNumberId', credential.phoneNumberId);
                    setFieldValue('wbaId', credential.wbaId);
                    setFieldValue('accessToken', credential.accessToken);
                    setFieldValue('apikey', credential.apikey);
                  }
                }
              }}
              className="custom-switch"
            />
          </div>
          <div className="col-6 mb-3">
            <Form.Check
              type="switch"
              id="is-ivr-switch"
              label="IVR"
              checked={values.isIvr || false}
              onChange={async (e) => {
                const checked = e.target.checked;
                setFieldValue('isIvr', checked);
                if (checked && selectedAdmin?._id) {
                  const ctcCred = await fetchCtcCredential(
                    dispatch,
                    selectedAdmin._id,
                  );
                  if (ctcCred) {
                    setFieldValue('CLINumber', ctcCred.CLINumber);
                  }
                }
              }}
              className="custom-switch"
            />
          </div>
          {values.isWadaddy && (
            <WaDaddyForm values={values} setFieldValue={setFieldValue} />
          )}
          {values.isIvr && (
            <CtcCredentialsForm values={values} setFieldValue={setFieldValue} />
          )}

          <div className="col-12">
            <Form.Group className="mb-3">
              <Form.Label>Password</Form.Label>
              <Form.Control
                type="text"
                name="password"
                value={values.password}
                onChange={(e) => setFieldValue('password', e.target.value)}
                placeholder="Enter password"
                className="shadow-none focus:!border-theme-dark"
              />
              <ErrorMessage
                name="password"
                component="div"
                className="text-danger"
              />
            </Form.Group>
          </div>
          {/* <div className="col-12">
            <Form.Group className="mb-3">
              <Form.Label>Facebook Page Access Token</Form.Label>
              <Form.Control
                type="text"
                name="facebookPageAccessToken"
                value={values.facebookPageAccessToken}
                onChange={(e) =>
                  setFieldValue('facebookPageAccessToken', e.target.value)
                }
                placeholder="Enter Facebook Page Access Token"
                className="shadow-none focus:!border-theme-dark"
              />
              <ErrorMessage
                name="facebookPageAccessToken"
                component="div"
                className="text-danger"
              />
            </Form.Group>
          </div> */}
          <div className="col-12">
            <Form.Group className="mb-3">
              <Form.Label>Facebook Page Access Tokens (max 5)</Form.Label>

              {values.facebookPageAccessTokens.map((token, index) => (
                <div
                  key={index}
                  className="d-flex align-items-center gap-2 mb-2"
                >
                  <Form.Control
                    type="text"
                    value={token}
                    onChange={(e) => {
                      const newTokens = [...values.facebookPageAccessTokens];
                      newTokens[index] = e.target.value;
                      setFieldValue('facebookPageAccessTokens', newTokens);
                    }}
                    placeholder={`Enter token #${index + 1}`}
                    className="shadow-none focus:!border-theme-dark"
                  />

                  {values.facebookPageAccessTokens.length > 1 && (
                    <Button
                      variant="danger"
                      size="sm"
                      onClick={() => {
                        const newTokens =
                          values.facebookPageAccessTokens.filter(
                            (_, i) => i !== index,
                          );
                        setFieldValue('facebookPageAccessTokens', newTokens);
                      }}
                    >
                      -
                    </Button>
                  )}

                  {index === values.facebookPageAccessTokens.length - 1 &&
                    values.facebookPageAccessTokens.length < 5 && (
                      <Button
                        variant="success"
                        size="sm"
                        onClick={() =>
                          setFieldValue('facebookPageAccessTokens', [
                            ...values.facebookPageAccessTokens,
                            '',
                          ])
                        }
                      >
                        +
                      </Button>
                    )}
                </div>
              ))}

              <ErrorMessage
                name="facebookPageAccessTokens"
                component="div"
                className="text-danger"
              />
            </Form.Group>
          </div>

          <div className="col-12">
            <Form.Group className="mb-3">
              <Form.Label>Logo</Form.Label>
              <Form.Control
                type="file"
                name="logo"
                accept="image/*"
                onChange={(e) => {
                  setFieldValue('logo', e.currentTarget.files[0]);
                }}
                className="shadow-none focus:!border-theme-dark"
              />
              {selectedAdmin && selectedAdmin.logo && (
                <div className="mt-2">
                  <img
                    src={selectedAdmin.logo}
                    alt="Current Logo"
                    style={{ maxWidth: '100px' }}
                    className="mt-2"
                  />
                </div>
              )}
            </Form.Group>
          </div>

          <div className="col-12 mb-3">
            {/* <Form.Check
              type="checkbox"
              id="voice-ai-permission-checkbox"
              label="Voice AI"
              checked={values.voiceAIPermission || false}
              onChange={(e) => {
                const checked = e.target.checked;
                setFieldValue('voiceAIPermission', checked);

                // if (checked) {
                //   if (!values.voiceAIDetails) {
                //     setFieldValue('voiceAIDetails', {
                //       OMNIDIM_API_KEY: '',
                //       OMNIDIM_DEFAULT_PHONE_NUMBER_ID: '',
                //       OMNIDIM_BASE_URL: '',
                //       callStatus: false,
                //     });
                //   }
                // } else {
                //   setFieldValue('voiceAIDetails', {
                //     OMNIDIM_API_KEY: '',
                //     OMNIDIM_DEFAULT_PHONE_NUMBER_ID: '',
                //     OMNIDIM_BASE_URL: '',
                //     callStatus: false,
                //   });
                // }
              }}
              className="custom-checkbox"
            /> */}
          </div>

          {values.voiceAIPermission && (
            <>
              <div className="col-12">
                <Form.Group className="mb-3">
                  <Form.Label>Omnidim API Key</Form.Label>
                  <Form.Control
                    type="text"
                    name="voiceAIDetails.OMNIDIM_API_KEY"
                    value={values.voiceAIDetails?.OMNIDIM_API_KEY || ''}
                    onChange={(e) => {
                      setFieldValue('voiceAIDetails', {
                        ...values.voiceAIDetails,
                        OMNIDIM_API_KEY: e.target.value,
                      });
                    }}
                    placeholder="Enter Omnidim API Key"
                    className="shadow-none focus:!border-theme-dark"
                  />
                  <ErrorMessage
                    name="voiceAIDetails.OMNIDIM_API_KEY"
                    component="div"
                    className="text-danger"
                  />
                </Form.Group>
              </div>
              <div className="col-12">
                <Form.Group className="mb-3">
                  <Form.Label>Omnidim Phone Number Id</Form.Label>
                  <Form.Control
                    type="text"
                    name="voiceAIDetails.OMNIDIM_DEFAULT_PHONE_NUMBER_ID"
                    value={
                      values.voiceAIDetails?.OMNIDIM_DEFAULT_PHONE_NUMBER_ID ||
                      ''
                    }
                    onChange={(e) => {
                      setFieldValue('voiceAIDetails', {
                        ...values.voiceAIDetails,
                        OMNIDIM_DEFAULT_PHONE_NUMBER_ID: e.target.value,
                      });
                    }}
                    placeholder="Enter Omnidim Phone Number Id"
                    className="shadow-none focus:!border-theme-dark"
                  />
                  <ErrorMessage
                    name="voiceAIDetails.OMNIDIM_DEFAULT_PHONE_NUMBER_ID"
                    component="div"
                    className="text-danger"
                  />
                </Form.Group>
              </div>
              <div className="col-12">
                <Form.Group className="mb-3">
                  <Form.Label>Omnidim Baseurl</Form.Label>
                  <Form.Control
                    type="text"
                    name="voiceAIDetails.OMNIDIM_BASE_URL"
                    value={values.voiceAIDetails?.OMNIDIM_BASE_URL || ''}
                    onChange={(e) => {
                      setFieldValue('voiceAIDetails', {
                        ...values.voiceAIDetails,
                        OMNIDIM_BASE_URL: e.target.value,
                      });
                    }}
                    placeholder="Enter Omnidim Baseurl"
                    className="shadow-none focus:!border-theme-dark"
                  />
                  <ErrorMessage
                    name="voiceAIDetails.OMNIDIM_BASE_URL"
                    component="div"
                    className="text-danger"
                  />
                </Form.Group>
              </div>
              <div className="col-12">
                <Form.Group className="mb-3">
                  <Form.Label>Call Status</Form.Label>
                  <Form.Select
                    name="voiceAIDetails.callStatus"
                    value={values.voiceAIDetails?.callStatus ? 'true' : 'false'}
                    onChange={(e) =>
                      setFieldValue(
                        'voiceAIDetails.callStatus',
                        e.target.value === 'true',
                      )
                    }
                    className="shadow-none focus:!border-theme-dark"
                  >
                    <option value="true">Yes</option>
                    <option value="false">No</option>
                  </Form.Select>
                </Form.Group>
              </div>
            </>
          )}
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button
          variant="secondary"
          onClick={handleClose}
          className="px-4 bg-transparent border-[1px] text-black border-green-color"
          disabled={isSubmitting}
        >
          Close
        </Button>
        <Button
          type="submit"
          className="!bg-theme-dark border-0 px-4 d-flex align-items-center gap-2"
          disabled={isSubmitting}
        >
          {selectedAdmin ? 'Update' : 'Add'}
        </Button>
      </Modal.Footer>
    </Form>
  );

  return (
    <>
      {isSubmitting && (
        <div className="loaderAdd">
          <div className="loader_line">
            <img src={logo} className="w-[200px]" />
          </div>
        </div>
      )}
      <div className="mt-[100px] d-flex justify-content-between">
        <div className="d-flex items-center gap-3">
          <Form.Group>
            <Form.Select
              value={selectedPlan}
              onChange={(e) => setSelectedPlan(e.target.value)}
              className="shadow-none focus:!border-theme-dark"
            >
              <option value="">All Plans</option>
              {plans?.getPlans?.data?.data?.map((plan) => (
                <option key={plan._id} value={plan._id}>
                  {plan.planName}
                </option>
              ))}
            </Form.Select>
          </Form.Group>
        </div>
        <div className="d-flex items-center gap-3">
          <div className="bg-white shadow-shadows py-[8px] px-[20px] rounded-full flex items-center gap-2">
            <IoSearchOutline />
            <input
              type="text"
              value={searchQuery}
              onChange={handleSearch}
              className="w-full outline-none"
              placeholder="Search..."
            />
          </div>
          <Button
            onClick={handleAddModalOpen}
            className="!bg-theme-dark fw-bold d-flex align-item-center border-0"
          >
            <IoMdAdd className="mt-1 gap-1" />
            Add Admin
          </Button>
        </div>
      </div>

      <div className="mt-[50px] mb-4">
        <div className="mb-3 flex items-center justify-between mt-5">
          <div className="d-flex align-items-center gap-2">
            <h3 className="fw-bold mb-0">All Admins List</h3>
          </div>
          <div className="d-flex align-items-center gap-4">
            <span className="bg-gray-100 text-gray-800 px-3 py-1 rounded-full text-sm fw-bold">
              Total : <span className="text-theme-dark">{totalCount}</span>
            </span>
            <div className="text-gray-800 fw-bold">Rows per page:</div>
            <select
              value={rowsPerPage}
              onChange={handleRowsPerPageChange}
              className="px-3 py-1 border rounded-md focus:outline-none focus:border-theme-dark fw-bold text-gray-800"
            >
              <option value={10}>10</option>
              <option value={30}>30</option>
              <option value={50}>50</option>
              <option value={100}>100</option>
            </select>
          </div>
        </div>

        <TableContainer>
          <Table variant="striped" colorScheme="blackAlpha">
            <Thead>
              <Tr>
                <Th>Logo</Th>
                <Th>Name</Th>
                <Th>Email</Th>
                <Th>Phone</Th>
                <Th>Plan</Th>
                <Th>Status</Th>
                <Th>Create By</Th>
                <Th>Branches</Th>
                <Th>Managers</Th>
                <Th>Leads</Th>
                <Th className="text-end">Action</Th>
              </Tr>
            </Thead>
            <Tbody>
              {admins?.getAdmins?.data?.AuthData &&
              admins?.getAdmins?.data?.AuthData.length > 0 ? (
                admins?.getAdmins?.data?.AuthData.map((admin) => (
                  <Tr key={admin._id}>
                    <Td>
                      {admin.logo ? (
                        <img
                          src={admin.logo}
                          alt={`${admin.name}'s logo`}
                          style={{
                            width: '50px',
                            height: '50px',
                            objectFit: 'contain',
                          }}
                        />
                      ) : (
                        'No Logo'
                      )}
                    </Td>
                    <Td>{admin.name}</Td>
                    <Td>{admin.email}</Td>
                    <Td>{admin.phoneNumber}</Td>
                    <Td>{admin.planId?.planName || 'No Plan'}</Td>
                    <Td>
                      <span
                        className={`px-2 inline-flex text-xs leading-5 font-semibold rounded-full ${
                          admin.isActive
                            ? 'bg-green-100 text-green-800'
                            : 'bg-red-100 text-red-800'
                        }`}
                      >
                        {admin.isActive ? 'Active' : 'Inactive'}
                      </span>
                    </Td>
                    <Td>{admin.admin_created_by?.name || ''}</Td>
                    <Td>{admin.branchCount || 0}</Td>
                    <Td>{admin.managerCount || 0}</Td>
                    <Td>{admin.leadCount || 0}</Td>
                    <Td>
                      <div className="d-flex gap-3 justify-end">
                        <FaEdit
                          onClick={() => handleUpdateModalOpen(admin)}
                          className="cursor-pointer border-green-color fs-5 text-success"
                          title="update"
                        />
                        <MdDelete
                          onClick={() => handleDeleteModalOpen(admin)}
                          className="cursor-pointer border-green-color fs-5 text-danger"
                          title="delete"
                        />
                      </div>
                    </Td>
                  </Tr>
                ))
              ) : (
                <Tr>
                  <Td colSpan={9} textAlign="center">
                    No Sub Admins Found
                  </Td>
                </Tr>
              )}
            </Tbody>
          </Table>
        </TableContainer>
      </div>

      <ReactPaginate
        breakLabel="..."
        nextLabel="next >"
        onPageChange={handlePageChange}
        pageRangeDisplayed={5}
        pageCount={Math.ceil(totalCount / rowsPerPage)}
        previousLabel="< previous"
        renderOnZeroPageCount={null}
        className="pagination"
      />

      {/* Add Modal */}
      <Modal show={show} onHide={handleAddModalClose}>
        <Modal.Header closeButton>
          <Modal.Title>Add Sub Admin</Modal.Title>
        </Modal.Header>
        <Formik
          initialValues={initialValues}
          validationSchema={validationSchema}
          onSubmit={handleSubmit}
        >
          {(formikProps) =>
            renderFormFields({
              ...formikProps,
              handleClose: handleAddModalClose,
            })
          }
        </Formik>
      </Modal>

      {/* Update Modal */}
      <Modal show={updateModal} onHide={handleUpdateModalClose}>
        <Modal.Header closeButton>
          <Modal.Title>Update Sub Admin</Modal.Title>
        </Modal.Header>
        <Formik
          initialValues={{
            name: selectedAdmin?.name || '',
            email: selectedAdmin?.email || '',
            phoneNumber: selectedAdmin?.phoneNumber || '',
            type: selectedAdmin?.type || 'Admin',
            planId: selectedAdmin?.planId?._id || '',
            startDate: selectedAdmin?.startDate?.split('T')[0] || '',
            endDate: selectedAdmin?.endDate?.split('T')[0] || '',
            password: selectedAdmin?.plainPassword || '',
            // facebookPageAccessToken:
            //   selectedAdmin?.facebookPageAccessToken || '',
            facebookPageAccessTokens:
              selectedAdmin?.facebookPageAccessTokens || [''],
            isActive: selectedAdmin?.isActive || false,
            voiceAIPermission: selectedAdmin?.voiceAIPermission || false,
            voiceAIDetails: {
              OMNIDIM_API_KEY:
                selectedAdmin?.voiceAIDetails?.OMNIDIM_API_KEY || '',
              OMNIDIM_DEFAULT_PHONE_NUMBER_ID:
                selectedAdmin?.voiceAIDetails
                  ?.OMNIDIM_DEFAULT_PHONE_NUMBER_ID || '',
              OMNIDIM_BASE_URL:
                selectedAdmin?.voiceAIDetails?.OMNIDIM_BASE_URL || '',
              callStatus: selectedAdmin?.voiceAIDetails?.callStatus || false,
            },
            isWadaddy: selectedAdmin?.isWadaddy || false,
            isIvr: selectedAdmin?.isIvr || false,
            CLINumber: ctcCredential?.CLINumber || '',
            facebookAppId: waDaddyCredential?.facebookAppId || '',
            registerdPhoneNumber: waDaddyCredential?.registerdPhoneNumber || '',
            phoneNumberId: waDaddyCredential?.phoneNumberId || '',
            wbaId: waDaddyCredential?.wbaId || '',
            accessToken: waDaddyCredential?.accessToken || '',
            apikey: waDaddyCredential?.apikey || '',
          }}
          validationSchema={validationSchema}
          onSubmit={handleUpdate}
          enableReinitialize
          context={{ isUpdate: true }}
        >
          {(formikProps) =>
            renderFormFields({
              ...formikProps,
              handleClose: handleUpdateModalClose,
            })
          }
        </Formik>
      </Modal>

      {/* Delete Modal */}
      <Modal show={deleteModal} onHide={handleDeleteModalClose}>
        <Modal.Body className="p-5">
          <div>
            <PiWarningCircleBold className="text-7xl w-100 text-danger" />
          </div>
          <div className="text-center mt-4">
            <h3>Are You Sure?</h3>
            <p className="text-md">
              Do you really want to delete this sub admin?
            </p>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={handleDeleteModalClose}
            className="px-4 bg-transparent border-[1px] text-black border-green-color"
          >
            No
          </Button>
          <Button
            type="button"
            className="bg-danger border-0 px-4"
            onClick={handleDelete}
          >
            Yes
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default SubAdminList;
